<template>
    <div>
        <!-- FASE 4 / BLOCO AD — DOC 34, 36, 39, 63, 64, 69, 70, 71, 72, 73, 77, 90-95 -->

        <el-tabs v-model="aba" @tab-click="trocar">
            <el-tab-pane label="Aguardando minha assinatura" name="pendencias"></el-tab-pane>
            <el-tab-pane label="Todos os procedimentos" name="todos"></el-tab-pane>
        </el-tabs>

        <!-- DOC 63, 64, 70, 73 -->
        <template v-if="aba === 'pendencias'">
            <el-row :gutter="10" class="u-mb-10" v-if="pendencias.length">
                <el-col :xs="24" :sm="12">
                    <el-select v-model="certificadoLote" placeholder="Certificado para assinar em lote"
                               style="width:100%">
                        <el-option v-for="c in certificados" :key="c.id"
                                   :label="c.nome + ' — ' + (c.cn || '')" :value="c.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <el-button type="primary" icon="el-icon-s-check" :disabled="!selecionadas.length || !certificadoLote"
                               @click="assinarLote">ASSINAR SELECIONADAS ({{ selecionadas.length }})</el-button>
                    <el-button class="u-ml-10" type="danger" icon="el-icon-close" :disabled="!selecionadas.length"
                               @click="dialogRecusaLote = true">RECUSAR SELECIONADAS</el-button>
                </el-col>
            </el-row>

            <div class="container-table" v-loading="!statusPend">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width:34px" class="u-text-center">
                                <el-checkbox :value="todasSel" @change="alternarTodas"></el-checkbox>
                            </th>
                            <th>Documento</th>
                            <th class="hidden-mobile">Natureza</th>
                            <th class="hidden-mobile u-text-center" style="width:130px">Prazo</th>
                            <th class="u-text-center" style="width:200px">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="p in pendencias" :key="p.id">
                            <td class="u-text-center">
                                <el-checkbox :value="selecionadas.indexOf(p.id) >= 0"
                                             @change="alternar(p.id)"></el-checkbox>
                            </td>
                            <td>
                                <router-link :to="'/admin/documento/detalhe/'+p.documento_id">{{ p.documento }}</router-link>
                            </td>
                            <td class="hidden-mobile meta">{{ p.natureza || '—' }}</td>
                            <td class="hidden-mobile u-text-center">
                                <span :class="vencido(p) ? 'vencido' : ''">{{ p.data_limite | formatarData }}</span>
                            </td>
                            <td class="u-text-center acao">
                                <el-button type="success" icon="el-icon-s-check" size="mini"
                                           @click="abrirAssinar(p)">ASSINAR</el-button>
                                <el-button class="u-ml-10" type="danger" icon="el-icon-close" size="mini"
                                           @click="abrirRecusar(p)">RECUSAR</el-button>
                            </td>
                        </tr>
                        <tr v-if="!pendencias.length && statusPend">
                            <td colspan="5" class="u-text-center u-mt-25">Nada aguardando sua assinatura.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>

        <!-- DOC 36, 69, 71, 77 -->
        <template v-else>
            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="12" :sm="5">
                    <el-input v-model="filtro.documento" placeholder="Documento" clearable
                              @keyup.native.enter="carregarTodos"></el-input>
                </el-col>
                <el-col :xs="12" :sm="5">
                    <el-input v-model="filtro.assinante" placeholder="Assinante" clearable
                              @keyup.native.enter="carregarTodos"></el-input>
                </el-col>
                <el-col :xs="12" :sm="4">
                    <el-input v-model="filtro.solicitante" placeholder="Solicitante" clearable
                              @keyup.native.enter="carregarTodos"></el-input>
                </el-col>
                <el-col :xs="12" :sm="4">
                    <el-input v-model="filtro.natureza" placeholder="Natureza" clearable
                              @keyup.native.enter="carregarTodos"></el-input>
                </el-col>
                <el-col :xs="12" :sm="3">
                    <el-select v-model="filtro.situacao" placeholder="Situação" clearable
                               style="width:100%" @change="carregarTodos">
                        <el-option label="Em andamento" value="em_andamento"></el-option>
                        <el-option label="Concluído"    value="concluido"></el-option>
                        <el-option label="Recusado"     value="recusado"></el-option>
                        <el-option label="Cancelado"    value="cancelado"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="3">
                    <el-date-picker v-model="filtro.de" type="date" placeholder="De"
                                    value-format="yyyy-MM-dd" style="width:100%" @change="carregarTodos"></el-date-picker>
                </el-col>
            </el-row>

            <div class="container-table" v-loading="!statusTodos">
                <table class="table table-striped">
                    <thead>
                        <tr><th>Documento</th><th class="hidden-mobile">Solicitante</th>
                            <th class="hidden-mobile">Natureza</th>
                            <th class="u-text-center" style="width:120px">Situação</th>
                            <th class="u-text-center" style="width:190px">Ação</th></tr>
                    </thead>
                    <tbody>
                        <tr v-for="p in todos" :key="p.id">
                            <td>
                                <router-link :to="'/admin/documento/detalhe/'+p.documento_id">{{ p.documento }}</router-link>
                            </td>
                            <td class="hidden-mobile meta">{{ p.solicitante }}</td>
                            <td class="hidden-mobile meta">{{ p.natureza || '—' }}</td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="corSituacao(p.situacao)">{{ p.situacao }}</el-tag>
                            </td>
                            <td class="u-text-center acao">
                                <el-button type="info" icon="el-icon-view" size="mini" plain
                                           title="Acompanhar" @click="verDetalhe(p)"></el-button>
                                <el-button class="u-ml-10" type="default" icon="el-icon-document" size="mini" plain
                                           title="Manifesto" @click="verManifesto(p)"></el-button>
                                <!--
                                  AF-3 / DOC 95 — "Permitir a impressão de um documento assinado".

                                  Dois botões, de propósito, porque servem a coisas diferentes:

                                    IMPRIMIR  o PDF com as assinaturas embarcadas, uma peça só,
                                              que abre no visualizador e se imprime direto
                                    PACOTE    o ZIP com os `.p7s`, para quem for validar no ITI

                                  Antes do AF-3 só existia o pacote, e imprimir "o documento
                                  assinado" significava montar a impressão a partir de duas peças.
                                -->
                                <el-button v-if="p.situacao === 'concluido'" type="success"
                                           icon="el-icon-printer" size="mini" plain
                                           title="Imprimir documento assinado"
                                           @click="imprimirAssinado(p)"></el-button>
                                <el-button class="u-ml-10" v-if="p.situacao === 'concluido'" type="primary"
                                           icon="el-icon-download" size="mini" plain
                                           title="Baixar pacote de assinaturas" @click="baixarPacote(p)"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!todos.length && statusTodos">
                            <td colspan="5" class="u-text-center u-mt-25">Nenhum procedimento encontrado.</td>
                        </tr>
                    </tbody>
                </table>

                <el-row v-if="statusTodos">
                    <el-col :xs="24" :sm="12">
                        <div class="u-text-left u-mt-10">
                            Mostrando {{ pag.from }} até {{ pag.to }} de {{ pag.qtdItens }} registros.
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" v-if="pag.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="pag.page" class="u-mt-10" :total="pag.qtdItens"
                                           @current-change="p => { pag.page = p; carregarTodos() }"
                                           :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </template>

        <!-- assinar -->
        <el-dialog title="Assinar documento" :visible.sync="dialogAssinar" width="520px">
            <p class="meta">
                A assinatura é feita com o seu certificado digital e vale para o arquivo
                exatamente como ele está agora.
            </p>
            <el-select v-model="certificadoEscolhido" placeholder="Escolha o certificado" style="width:100%">
                <el-option v-for="c in certificados" :key="c.id"
                           :label="c.nome + ' — ' + (c.cn || '')" :value="c.id"></el-option>
            </el-select>
            <p v-if="!certificados.length" class="aviso">
                Você ainda não tem certificado cadastrado.
                <router-link to="/admin/documento/certificado">Cadastrar agora</router-link>.
            </p>
            <span slot="footer">
                <el-button @click="dialogAssinar = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" :disabled="!certificadoEscolhido" @click="assinar">ASSINAR</el-button>
            </span>
        </el-dialog>

        <!-- recusar (DOC 91) -->
        <el-dialog title="Recusar assinatura" :visible.sync="dialogRecusar" width="520px">
            <el-input v-model="motivo" type="textarea" :rows="4" maxlength="500"
                      placeholder="Justifique a recusa (obrigatório)"></el-input>
            <span slot="footer">
                <el-button @click="dialogRecusar = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="danger" @click="recusar">RECUSAR</el-button>
            </span>
        </el-dialog>

        <!-- recusar em lote (DOC 92) -->
        <el-dialog title="Recusar selecionadas" :visible.sync="dialogRecusaLote" width="520px">
            <el-input v-model="motivo" type="textarea" :rows="4" maxlength="500"
                      placeholder="Justifique a recusa (obrigatório)"></el-input>
            <span slot="footer">
                <el-button @click="dialogRecusaLote = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="danger" @click="recusarLote">RECUSAR TODAS</el-button>
            </span>
        </el-dialog>

        <!-- acompanhamento (DOC 34, 39) -->
        <el-dialog title="Andamento das assinaturas" :visible.sync="dialogDetalhe" width="680px">
            <div v-if="detalhe">
                <p class="meta">
                    {{ detalhe.assinados }} de {{ detalhe.total }} assinatura(s) ·
                    código de verificação
                    <strong>{{ detalhe.procedimento.codigo_verificacao }}</strong>
                </p>
                <table class="table table-striped">
                    <thead>
                        <tr><th>Assinante</th><th style="width:120px">Situação</th>
                            <th style="width:140px">Quando</th><th>Certificado</th></tr>
                    </thead>
                    <tbody>
                        <tr v-for="a in detalhe.assinantes" :key="a.id">
                            <td>{{ a.nome_usuario || a.nome_externo || a.assinante_cn }}</td>
                            <td>
                                <el-tag size="mini" :type="a.situacao === 'assinado' ? 'success'
                                        : (a.situacao === 'recusado' ? 'danger' : 'info')">
                                    {{ a.situacao }}
                                </el-tag>
                            </td>
                            <td class="meta">{{ a.assinado_em | formatarData }}</td>
                            <td class="meta">
                                {{ a.certificado_emissor || '—' }}
                                <div v-if="a.motivo_recusa" class="recusa">{{ a.motivo_recusa }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- DOC 37, 93 -->
                <div v-if="detalhe.sou_solicitante && detalhe.procedimento.situacao === 'em_andamento'"
                     class="u-text-right u-mt-10">
                    <el-button type="danger" size="small" @click="cancelar">CANCELAR PROCEDIMENTO</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import moment from 'moment'

export default {
    filters: {
        formatarData (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—' }
    },
    data: () => ({
        aba: 'pendencias',
        statusPend: false, pendencias: [], selecionadas: [],
        statusTodos: false, todos: [],
        pag: { page: 1, qtdItens: 0, from: '', to: '' },
        filtro: { documento: '', assinante: '', solicitante: '', natureza: '', situacao: '', de: '' },
        certificados: [], certificadoEscolhido: '', certificadoLote: '',
        dialogAssinar: false, dialogRecusar: false, dialogRecusaLote: false, dialogDetalhe: false,
        alvo: null, motivo: '', detalhe: null
    }),
    computed: {
        todasSel () { return this.pendencias.length > 0 && this.selecionadas.length === this.pendencias.length }
    },
    mounted () {
        this.carregarCertificados()
        this.carregarPendencias()
    },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const d = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (d && typeof d.erro === 'string') msg = d.erro
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        corSituacao (s) {
            if (s === 'concluido') return 'success'
            if (s === 'recusado')  return 'danger'
            if (s === 'cancelado') return 'info'
            return 'primary'
        },

        vencido (p) { return p.data_limite && moment(p.data_limite).isBefore(moment()) },

        trocar () {
            if (this.aba === 'todos' && !this.todos.length) this.carregarTodos()
        },

        carregarCertificados () {
            this.$axios.post(`${this.base()}/api/certificado-digital/utilizaveis`, {}, this.auth())
                .then(r => { this.certificados = r.data })
                .catch(() => { this.certificados = [] })
        },

        carregarPendencias () {
            this.statusPend = false
            this.selecionadas = []
            this.$axios.post(`${this.base()}/api/documento-assinatura/pendencias`, {}, this.auth())
                .then(r => { this.pendencias = r.data.data; this.statusPend = true })
                .catch(e => { this.statusPend = true; this.erro(e) })
        },

        carregarTodos () {
            this.statusTodos = false
            this.$axios.post(`${this.base()}/api/documento-assinatura/listar?page=${this.pag.page}`,
                this.filtro, this.auth()).then(r => {
                this.todos = r.data.data
                this.pag.qtdItens = r.data.total
                this.pag.from = r.data.from
                this.pag.to = r.data.to
                this.statusTodos = true
            }).catch(e => { this.statusTodos = true; this.erro(e) })
        },

        alternar (id) {
            const i = this.selecionadas.indexOf(id)
            if (i >= 0) this.selecionadas.splice(i, 1)
            else this.selecionadas.push(id)
        },

        alternarTodas () {
            this.selecionadas = this.todasSel ? [] : this.pendencias.map(p => p.id)
        },

        abrirAssinar (p) { this.alvo = p; this.certificadoEscolhido = ''; this.dialogAssinar = true },
        abrirRecusar (p) { this.alvo = p; this.motivo = ''; this.dialogRecusar = true },

        assinar () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-assinatura/assinar/${this.alvo.id}`,
                { certificado_id: this.certificadoEscolhido }, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)
                const concluiu = r.data.procedimento.situacao === 'concluido'
                window.eventBus.$emit('alert', {
                    msg: 'Sucesso! - ' + (concluiu ? 'Documento totalmente assinado.' : 'Documento assinado.'),
                    type: 'success'
                })
                this.dialogAssinar = false
                this.carregarPendencias()
            }).catch(e => { this.erro(e) })
        },

        assinarLote () {
            this.$msgbox.confirm(
                `Assinar ${this.selecionadas.length} documento(s) com o mesmo certificado?`, 'Confirmar',
                { confirmButtonText: 'Assinar', cancelButtonText: 'Cancelar' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.base()}/api/documento-assinatura/assinar-lote`,
                    { assinantes: this.selecionadas, certificado_id: this.certificadoLote },
                    this.auth()).then(r => {
                    window.eventBus.$emit('loading', false)
                    let msg = `${r.data.assinados} assinatura(s) concluída(s).`
                    if (r.data.falhas.length) msg += ` ${r.data.falhas.length} não foi possível.`
                    window.eventBus.$emit('alert', { msg: msg, type: r.data.falhas.length ? 'warning' : 'success' })
                    this.carregarPendencias()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        recusar () {
            if (!this.motivo || !this.motivo.trim()) {
                window.eventBus.$emit('alert', { msg: 'Justifique a recusa.', type: 'warning' })
                return
            }
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-assinatura/recusar/${this.alvo.id}`,
                { motivo: this.motivo }, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Assinatura recusada.', type: 'success' })
                this.dialogRecusar = false
                this.carregarPendencias()
            }).catch(e => { this.erro(e) })
        },

        recusarLote () {
            if (!this.motivo || !this.motivo.trim()) {
                window.eventBus.$emit('alert', { msg: 'Justifique a recusa.', type: 'warning' })
                return
            }
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-assinatura/recusar-lote`,
                { assinantes: this.selecionadas, motivo: this.motivo }, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: `${r.data.recusados} recusa(s) registrada(s).`, type: 'success' })
                this.dialogRecusaLote = false
                this.carregarPendencias()
            }).catch(e => { this.erro(e) })
        },

        verDetalhe (p) {
            this.$axios.get(`${this.base()}/api/documento-assinatura/detalhe/${p.id}`, this.auth())
                .then(r => { this.detalhe = r.data; this.dialogDetalhe = true })
                .catch(e => { this.erro(e) })
        },

        cancelar () {
            this.$msgbox.confirm('Cancelar este procedimento de assinatura?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.base()}/api/documento-assinatura/cancelar/${this.detalhe.procedimento.id}`,
                    {}, this.auth()).then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Procedimento cancelado.', type: 'success' })
                    this.dialogDetalhe = false
                    this.carregarTodos()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        verManifesto (p) {
            const cfg = Object.assign({}, this.auth())
            cfg.responseType = 'blob'
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.base()}/api/documento-assinatura/manifesto/${p.id}`, cfg).then(r => {
                window.eventBus.$emit('loading', false)
                window.open(window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' })), '_blank')
            }).catch(e => { this.erro(e) })
        },

        /*
         * DOC 95 — abre o PDF assinado no visualizador, de onde o usuário imprime.
         *
         * O 404 tem tratamento próprio: um procedimento cujo arquivo não é PDF não tem
         * artefato PAdES, e dizer "não foi possível baixar" esconderia o motivo. A mensagem
         * aponta o pacote, que é o caminho que existe para esse caso.
         */
        imprimirAssinado (p) {
            const cfg = Object.assign({}, this.auth())
            cfg.responseType = 'blob'
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.base()}/api/documento-assinatura/baixar-assinado/${p.id}`, cfg).then(r => {
                window.eventBus.$emit('loading', false)
                window.open(window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' })), '_blank')
            }).catch(e => {
                window.eventBus.$emit('loading', false)
                if (e.response && e.response.status === 404) {
                    this.$message({
                        type: 'warning',
                        message: 'Este documento não tem versão assinada em PDF. Use o pacote de assinaturas.'
                    })
                    return
                }
                this.erro(e)
            })
        },

        baixarPacote (p) {
            const cfg = Object.assign({}, this.auth())
            cfg.responseType = 'blob'
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.base()}/api/documento-assinatura/baixar-pacote/${p.id}`, cfg).then(r => {
                window.eventBus.$emit('loading', false)
                const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/zip' }))
                const a = document.createElement('a')
                a.href = url; a.download = 'documento-assinado-' + p.id + '.zip'
                document.body.appendChild(a); a.click(); document.body.removeChild(a)
                window.URL.revokeObjectURL(url)
            }).catch(e => { this.erro(e) })
        }
    }
}
</script>
<style scoped>
.meta   { font-size: 12px; color: #909399; }
.vencido{ color: #F56C6C; font-weight: 600; }
.aviso  { font-size: 13px; color: #E6A23C; margin-top: 8px; }
.recusa { font-size: 11px; color: #F56C6C; }
</style>
